import { Button } from '@repo/design-system-kit';
import { IconArrowLeftOutlined, IconCrossOutlined } from '@repo/monochrome-icons';
import { useIntl } from 'react-intl';
import cx from 'clsx';
import { useFlow } from '../flow-provider.tsx';
import styles from './flow-header.module.css';

export function FlowHeader({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}): JSX.Element {
  const flow = useFlow();
  const intl = useIntl();
  const handleGoBack = (): void => {
    flow.goBack?.(flow.params);
  };

  return (
    <nav className={cx(styles.container, className)}>
      <Button
        aria-label={intl.formatMessage({
          id: 'a11y.buttons.back-aria-label',
          defaultMessage: 'Back',
        })}
        className={cx(flow.goBack === undefined && styles.hideBack)}
        data-test-flow-header-back
        data-testid="flow-header-back"
        iconOnly
        onPress={handleGoBack}
        variant="tertiary"
      >
        <IconArrowLeftOutlined />
      </Button>

      {children}

      <Button
        aria-label={intl.formatMessage({
          id: 'a11y.buttons.close-aria-label',
        })}
        data-flow-header-close
        data-testid="flow-header-close"
        iconOnly
        onPress={flow.close}
        variant="tertiary"
      >
        <IconCrossOutlined />
      </Button>
    </nav>
  );
}
